import { CSSProperties, FC } from 'react'

import { match } from 'ts-pattern'

import {
  Text,
  Primary12Regular,
  RedRed10,
  RedRed80,
  YellowYellow10,
  YellowYellow80
} from '@sequencehq/core-components'

import { ValidationLevel } from 'Automations/nodeDefinitions'

export const CountPill: FC<{ count: number; level: ValidationLevel }> = ({
  count,
  level
}) => {
  const styles: Pick<CSSProperties, 'backgroundColor' | 'color'> = match(level)
    .with('ERROR', () => ({
      backgroundColor: RedRed10,
      color: RedRed80
    }))
    .with('WARN', () => ({
      backgroundColor: YellowYellow10,
      color: YellowYellow80
    }))
    .exhaustive()

  const testId = match(level)
    .with('ERROR', () => 'automations.editor.workflowErrors.errorCount')
    .with('WARN', () => 'automations.editor.workflowErrors.warningCount')
    .exhaustive()

  return (
    <Text
      data-testid={testId}
      {...Primary12Regular}
      {...styles}
      py="1px"
      px="8px"
      borderRadius="18px"
    >
      {count}
    </Text>
  )
}
